export default __webpack_public_path__ + "81b8e89432e13addc109aaaaf66cc09a.svg";